<template>
    <span>
        <a
            :aria-expanded="enumCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="enumCollaps=!enumCollaps">
            <template>
                <i class="fa pr-2 fa-globe text-danger"></i>
                <span class="nav-link-text">ENUM <b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="enumCollaps" id="collapse-just1" :class="enumCollaps?'show':''" class="collapse collapse-just">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            test="navPermissions['enumTool'].enable"
                            :target="link.target"
                            class="nav-link"
                            href="/enum/tool"
                            to="/enum/tool"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-plug text-green pr-2"></i>
                                <span class="nav-link-text">Enum Tool</span>
                            </template>
                        </router-link>
                    </slot>
                </ul>
            </div>
        </collapse-transition>  
    </span>
</template>

<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "../../../common/api-services/init-service";

export default {
    name: 'side-enum-group',
    components: {
        CollapseTransition
    },
    data() {
        return {
            isPortalAdminStatus: false,
            isAdminStatus: false,
            enumCollaps: false,
            link: {
                name: '',
                icon: '',
                path: '',
                children: []
            },
            navPermissions: {
                "enumTool": {
                    enable: false,
                    role: ["PORTAL_ADMIN"]
                },
            }
        }
    },
    mounted() {
        this.isPortalAdminStatus = initService.getPortalAdminRole();
        this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
        this.groups = initService.getGroups();
        //console.log('GROUPS:',this.groups)
        Object.keys(this.navPermissions).map(item => {
        this.groups.map(it => {
            if (this.navPermissions[item].role.includes(it))
                this.navPermissions[item].enable = true;
            });
        });
    },
    methods: {
        linkClick() {
            if (
                this.autoClose &&
                this.$sidebar &&
                this.$sidebar.showSidebar === true
            ) {
                this.$sidebar.displaySidebar(false);
            }
        },
    }
}
</script>